import { createContext, useMemo } from 'react';
import useBaseDomain from './useBaseDomain';

export type baseDomain = {
  baseDomain: string;
};
const INITIAL_CONTEXT = { baseDomain: '' };

const Context = createContext<baseDomain>(INITIAL_CONTEXT);

const Provider = ({
  children,
  baseDomain,
}: {
  children: JSX.Element | JSX.Element[];
  baseDomain?: string;
}) => {
  const value = useMemo(
    () => ({
      baseDomain: baseDomain || '',
    }),
    [baseDomain]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export default Provider;

export { Context, useBaseDomain };
